import type { RenderQualityConfig } from "../render/types.ts";

export const RENDER_QUALITY_CONFIG: RenderQualityConfig = Object.freeze({
  maxPixelRatio: 1,
  shadowMapSize: 2048,
});
